





















import { Component, Vue } from "vue-property-decorator";
import VueApexCharts from "vue-apexcharts";

@Component({
  components: {
    apexchart: VueApexCharts,
  },
})
export default class MileageCard extends Vue {
  chipToggle = 1;

  options: any = {
    chart: {
      id: "vuechart-example",
    },
    colors: ["#0770a4"],
    markers: {
      strokeWidth: 0,
      size: 9,
    },
    dataLabels: {
      enabled: true,
      style: {
        fontFamily: "Toyota Type",
        fontSize: "18",
        fontWeight: "bold",
      },
      offsetY: -18,
      background: {
        enabled: true,
        foreColor: "#fff",
        borderRadius: 5,
        padding: 20,
        opacity: 0.9,
        borderWidth: 0,
        dropShadow: {
          enabled: true,
          left: 0,
          top: 2,
          opacity: 0.2,
        },
      },
    },
    grid: {
      show: true,
      padding: {
        bottom: 0,
      },
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    xaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        format: "yyyy",
        offsetY: 3,
        style: {
          colors: "#fff",
          fontSize: "18px",
          fontFamily: "Toyota Type, sans-serif",
          fontWeight: 500,
          cssClass: "apexcharts-xaxis-label",
        },
      },
      lines: {
        show: true,
      },
      type: "datetime",
    },
    legend: {
      show: false,
    },
    stroke: {
      dashArray: [0, 4],
    },
    yaxis: {
      show: false,
      labels: {
        style: {
          fontSize: "18px",
          fontFamily: "Toyota Type, sans-serif",
          fontWeight: 500,
        },
      },
      lines: {
        show: false,
      },
    },
  };

  series: any[] = [
    {
      name: "Actual",
      data: [
        { x: new Date("2020-10-01"), y: null },
        { x: new Date("2021-04-01"), y: 232 },
        { x: new Date("2022-04-01"), y: 1457 },
        { x: new Date("2023-04-01"), y: null },
        { x: new Date("2024-04-01"), y: null },
        { x: new Date("2025-04-01"), y: null },
        { x: new Date("2026-04-01"), y: null },
        { x: new Date("2026-10-01"), y: null },
      ],
    },
    {
      name: "Estimated",
      data: [
        { x: new Date("2022-04-01"), y: 1457 },
        { x: new Date("2023-04-01"), y: 13457 },
        { x: new Date("2024-04-01"), y: 25457 },
        { x: new Date("2025-04-01"), y: 37457 },
        { x: new Date("2026-04-01"), y: 49457 },
        { x: new Date("2026-10-01"), y: null },
      ],
    },
  ];
}
